export enum UserCultureEnum {
  it = 0,
  fr = 1,
  en = 2,
  es = 3,
  de = 4
}
